import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { fetchExpertiseCall, sendRepairOffer } from 'src/api/expertise';
import CartRequestDTO from 'src/entities/cart/request/CartRequestDTO';
import { getShoppingCart, ShoppingCartEntityState } from '../cart/selectors';
import { enqueueSnackbarAction } from '../notifications/actions';
import {
    FETCH_EXPERTISE,
    FETCH_SEND_REPAIR_OFFER,
    requestExpertise,
    requestExpertiseFailure,
    requestExpertiseSuccess,
} from './actions';

function* fetchExpertiseSaga(action: AnyAction): SagaIterator {
    yield put(requestExpertise());

    const { error, response } = yield call(fetchExpertiseCall);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: 'Reparaturangebote konnten nicht geladen werden!\n' + error.message, // i18next.t('translations:order_table.success_add')
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                },
            })
        );
        yield put(requestExpertiseFailure(error));
    } else {
        // yield put(
        //     enqueueSnackbarAction({
        //         message: 'Reparaturangebote erfolgreich geladen', // i18next.t('translations:order_table.success_add')
        //         options: {
        //             key: new Date().getTime() + Math.random(),
        //             variant: 'success',
        //         },
        //     })
        // );
        yield put(requestExpertiseSuccess(response));
    }
}

function* fetchSendRepairOfferSaga(action: AnyAction): SagaIterator {
    yield put(requestExpertise());

    const existingShoppingCart: ShoppingCartEntityState = yield select(getShoppingCart);
    const cartRequestDTOAdmin = CartRequestDTO.FromShoppingCartWithSubmitBookingFormData(
        existingShoppingCart.content,
        action.data
    );

    const { error, response } = yield call(sendRepairOffer, cartRequestDTOAdmin);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: 'Angebot konnte nicht verschickt werden!\n' + error.message, // i18next.t('translations:order_table.success_add')
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                },
            })
        );
        yield put(requestExpertiseFailure(error));
    } else {
        yield put(
            enqueueSnackbarAction({
                message: 'Angebot erfolgreich verschickt!', // i18next.t('translations:order_table.success_add')
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'success',
                },
            })
        );
    }
}

export function* generateFetchExpertise() {
    yield takeLatest(FETCH_EXPERTISE, fetchExpertiseSaga);
}

export function* generateSendRepairOffer() {
    yield takeLatest(FETCH_SEND_REPAIR_OFFER, fetchSendRepairOfferSaga);
}
